import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DataBagService } from 'src/app/common/data-bag.service';
import { OrganizationService } from '../organization.service';
import { OrganizationWorkersAddComponent } from './organization-workers-add/organization-workers-add.component';
import { OrganizationWorkersEditComponent } from './organization-workers-edit/organization-workers-edit.component';

@Component({
	selector: 'app-organization-workers',
	templateUrl: './organization-workers.component.html',
	styleUrls: ['./organization-workers.component.scss'],
})
export class OrganizationWorkersComponent implements OnInit {
	workersData = new MatTableDataSource<any>();
	@ViewChild('usersTable') table: MatTable<any>;
	workersColumns = ['firstName', 'lastName', 'email', 'department', 'role', 'edit'];

	constructor(
		public organizationService: OrganizationService,
		public dialog: MatDialog,
		public route: ActivatedRoute,
		private readonly bag: DataBagService,
	) {}

	ngOnInit(): void {
		this.route.params.subscribe((params: Params) => {
			this.bag.get(
				`/organization/user/?organization=${this.organizationService.organizationData.id}`,
				(result, error) => {
					if (result) {
						this.organizationService.enterpriseData.users = result.results;
						this.workersData.data = result.results;
					}
				},
			);

			this.bag.get(
				`/organization/department/?organization=${this.organizationService.organizationData.id}`,
				(result, error) => {
					if (result) {
						this.organizationService.enterpriseData.departmentsForUsers = result.results;
					}
				},
			);
		});
	}

	getRole(role): string {
		const findRole = this.organizationService.enterpriseData.organizationRoles.find(
			(findRole) => findRole.id === role,
		);
		return findRole?.name ? findRole.name : '';
	}

	getDepartment(department): string {
		const findDepartmentsForUsers = this.organizationService.enterpriseData.departmentsForUsers.find(
			(departmentObj) => departmentObj.id === department,
		);
		if (!findDepartmentsForUsers) {
			return '';
		}

		const findDepartment = this.organizationService.enterpriseData.departmentKinds.find(
			(findDep) => findDep.id === findDepartmentsForUsers.kind,
		);

		return findDepartment?.name ? findDepartment.name : '';
	}

	openWorkersAdd(): void {
		this.dialog
			.open(OrganizationWorkersAddComponent)
			.afterClosed()
			.subscribe((result) => {
				this.workersData.data = this.organizationService.enterpriseData.users;
				this.table.renderRows();
			});
	}

	openWorkersEdit(worker): void {
		this.dialog
			.open(OrganizationWorkersEditComponent, { data: worker })
			.afterClosed()
			.subscribe((result) => {
				this.workersData.data = this.organizationService.enterpriseData.users;
				this.table.renderRows();
			});
	}
}
